<template>
  <p class="page-container">404 page not found</p>
</template>

<script>
export default {
  name: "page404",
  mounted() {
    // if (!localStorage.getItem("TOKEN") || !this.$store.state.TOKEN) {
    //   this.$router.replace({
    //     path: "/login"
    //   })
    //   return 
    // }
  }
};
</script>

<style scoped>
.page-container {
  font-size: 20px;
  text-align: center;
  color: rgb(192, 204, 218);
}
</style>